import type { Project } from "@proof/core";

export interface ProjectDeletionResult {
  deleted: number;
  skipped: { project: Project; reason: string }[];
}

export const canDeleteProject = (project: Pick<Project, "usedAt" | "status">) =>
  !project.usedAt && project.status !== "published";

/** Finish the selection even when a project is protected or a request fails. */
export async function deleteProjects(
  projects: Project[],
  remove: (project: Project) => Promise<void>,
): Promise<ProjectDeletionResult> {
  const result: ProjectDeletionResult = { deleted: 0, skipped: [] };
  for (const project of projects) {
    if (!canDeleteProject(project)) {
      result.skipped.push({
        project,
        reason: "This project has been used or published. Archive it instead.",
      });
      continue;
    }
    try {
      await remove(project);
      result.deleted++;
    } catch (cause) {
      result.skipped.push({
        project,
        reason:
          cause instanceof Error
            ? cause.message
            : "The project could not be deleted.",
      });
    }
  }
  return result;
}
